import React__default, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { WithLightTheme } from '@statsbomb/kitbag-themes';
import { MenuList } from './SideNavigationMenuList.styles.js';
import { useSideNavigationThemeContext } from '../SideNavigationContexts/SideNavigationThemeContext.js';

var SideNavigationMenuList = function SideNavigationMenuList(_ref) {
  var children = _ref.children,
    _ref$selectedSubMenu = _ref.selectedSubMenu,
    selectedSubMenu = _ref$selectedSubMenu === void 0 ? undefined : _ref$selectedSubMenu,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var _useSideNavigationThe = useSideNavigationThemeContext(),
    isTouch = _useSideNavigationThe.isTouch,
    isDarkMode = _useSideNavigationThe.isDarkMode;
  var renderOriginalTheme = !isDarkMode && isTouch;
  var Component = renderOriginalTheme ? WithLightTheme : React__default.Fragment;
  var menuListRef = useRef(null);
  useEffect(function () {
    var _menuListRef$current;
    menuListRef === null || menuListRef === void 0 || (_menuListRef$current = menuListRef.current) === null || _menuListRef$current === void 0 || _menuListRef$current.scrollTo({
      behavior: 'smooth',
      top: 0
    });
  }, [selectedSubMenu]);
  return React__default.createElement(Component, null, React__default.createElement(MenuList, {
    ref: menuListRef,
    $hasOverflow: !selectedSubMenu,
    "data-testid": testId,
    $isSubMenuOpen: isTouch && selectedSubMenu
  }, children));
};
SideNavigationMenuList.propTypes = {
  children: PropTypes.node.isRequired,
  selectedSubMenu: PropTypes.string,
  testId: PropTypes.string
};

export { SideNavigationMenuList, SideNavigationMenuList as default };
//# sourceMappingURL=SideNavigationMenuList.js.map
